if (!customElements.get('estoria-email-popup')) {
  customElements.define('estoria-email-popup', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal || this.dataset.designMode === 'true') return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-popup-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dismiss(); }, options);
      this.querySelector('form')?.addEventListener('submit', () => {
        this.writeStorage('sessionStorage', 'estoria-email-pending', '1');
      }, options);
      const result = this.querySelector('[data-popup-success], [data-popup-error]');
      const hash = window.location.hash;
      if (result && hash && hash !== '#EstoriaEmailSignup') {
        this.writeStorage('sessionStorage', 'estoria-email-pending', '');
        return;
      }
      const returning = hash === '#EstoriaEmailSignup' || (!hash && this.readStorage('sessionStorage', 'estoria-email-pending') === '1');
      if (returning && result) {
        this.writeStorage('sessionStorage', 'estoria-email-pending', '');
        if (result.matches('[data-popup-success]')) {
          this.writeStorage('localStorage', 'estoria-email-subscribed', '1');
        }
        this.show();
        result.focus();
      } else if (this.eligible()) {
        this.timer = setTimeout(() => this.tryShow(), Number(this.dataset.delay || 15) * 1000);
      }
    }
    readStorage(storage, key) {
      try { return window[storage].getItem(key); } catch { return null; }
    }
    writeStorage(storage, key, value) {
      try { window[storage].setItem(key, value); } catch { /* Signup remains usable when storage is blocked. */ }
    }
    eligible() {
      return this.dataset.subscribed !== 'true' && this.readStorage('localStorage', 'estoria-email-subscribed') !== '1' && this.readStorage('sessionStorage', 'estoria-email-shown') !== '1';
    }
    tryShow() {
      if (!this.isConnected || !this.eligible()) return;
      const busy = document.hidden || document.querySelector('dialog[open], cart-drawer.active, menu-drawer details[open], header-drawer details[open], details-modal details[open], product-modal[open], quick-add-modal[open]') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      if (busy) this.timer = setTimeout(() => this.tryShow(), 3000);
      else this.show();
    }
    show() {
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      document.documentElement.classList.add('estoria-email-popup-open');
      this.writeStorage('sessionStorage', 'estoria-email-shown', '1');
    }
    dismiss() {
      this.dialog.close();
      document.documentElement.classList.remove('estoria-email-popup-open');
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('estoria-email-popup-open');
    }
  });
}
